/* rb-b-quickadd.js — repair the quick-add sheet's sold-out states.

   DESKTOP ONLY (>=981px). This file originally said "desktop and mobile both:
   this is a correctness fix, not a layout treatment" and ran everywhere. That
   was overruled — Mark's requirement is that MOBILE IS EXACTLY THE LIVE SITE,
   with no exceptions for improvements. The bug it fixes is the theme's and is
   still present on mobile as a result; that is the deliberate trade. Do not
   remove the guard below to "fix mobile too".

   THE BUG IS THE THEME'S, NOT OURS, and it is on live today: whenever more
   than one value of the SAME option is filtered, the card's Liquid marks every
   size pill sold out. Proven by running the identical three size values
   through the live theme with one change event — it breaks exactly the same
   way — while live with a single value, and the preview with a brand filter,
   are both correct.

   WE MADE IT EASY TO HIT on desktop, which is why it is fixed there: the
   merged shoe chip sends 2-3 values in one click, so every shoe-size filter
   lands on it. Mark saw all five sizes struck through on a shoe whose product
   page happily sells 10, 11 and 12.

   THE PAGE ALREADY CONTAINS THE TRUTH, which is what makes this cheap and
   safe. Every card embeds script.js-quick-add-variants, and that blob stays
   CORRECT even when the pills are wrong:

     [47771252850920,"Caffe'","9 (EU 42)",0,...]   <- 0 = sold out
     [47771237417192,"Caffe'","10 (EU 43)",1,...]  <- 1 = available

   matching the product page exactly. So no network call and no touching the
   89KB card section: re-derive each pill from the blob after every render.

   TWO PILL LAYERS, AND ONLY ONE OF THEM IS VISIBLE. This cost a wrong guess
   earlier, so it is written down:

     .js-quick-add-pill  the theme's. Carries data-variant-id, uses [disabled].
                         Its container computes display:none here — NOT what
                         the shopper sees.
     .js-rb-qa-pill      a custom layer with a Notify flow. This is the visible
                         one (its container is display:grid), and it does not
                         use [disabled] at all: the strikethrough comes from
                         .rb-qa-pill[data-soldout="1"]:after in
                         rooster-critical.css / rooster-commerce.css.

   Fixing only [disabled] would have changed nothing on screen while every
   check passed. Both layers are corrected, and the visible one is driven from
   the theme pill of the same size, because that pill carries the variant id
   and is therefore correct for the colour currently shown. Aggregating "is any
   variant of this size available" across colours would light up a size that is
   only in stock in a different colourway.

   The CSS hook was found by FETCHING the stylesheets as text. document.
   styleSheets[].cssRules throws on the cross-origin cdn.shopify.com sheets and
   silently returns nothing, which has hidden a rule from me three times in
   this project. */

(function () {
  'use strict';

  /* MOBILE PARITY GUARD — see the note at the top. */
  if (!window.matchMedia('(min-width: 981px)').matches) return;

  var applying = false;

  /* The blob and the pills share an ancestor, but which one varies by card
     template, so walk up from the sheet until an element contains both. */
  function scopeFor(sheet) {
    var el = sheet.parentElement;
    while (el && el !== document.body) {
      var tag = el.querySelector('script.js-quick-add-variants');
      if (tag) return { scope: el, tag: tag };
      el = el.parentElement;
    }
    return null;
  }

  function parse(tag) {
    var rows;
    try { rows = JSON.parse(tag.textContent); } catch (e) { return null; }
    if (!rows || !rows.length) return null;

    var byId = {}, bySizeAny = {};
    rows.forEach(function (r) {
      if (!r || r.length < 4) return;
      var id = String(r[0]), size = String(r[2]), ok = (r[3] === 1 || r[3] === true);
      byId[id] = ok;
      bySizeAny[size] = bySizeAny[size] || ok;
    });
    return { byId: byId, bySizeAny: bySizeAny };
  }

  function fix(sheet) {
    var found = scopeFor(sheet);
    if (!found) return;
    var data = parse(found.tag);
    if (!data) return;

    var scope = found.scope;
    var bySize = {};

    // Theme layer: authoritative, because each pill names its variant.
    scope.querySelectorAll('.js-quick-add-pill').forEach(function (b) {
      var id = b.getAttribute('data-variant-id');
      var size = b.getAttribute('data-size');
      var ok = (id && Object.prototype.hasOwnProperty.call(data.byId, String(id)))
        ? data.byId[String(id)]
        : data.bySizeAny[size];
      if (ok === undefined) return;

      if (size) bySize[size] = ok;

      if (b.disabled === !ok) return;          // already right; do not churn
      b.disabled = !ok;
      b.setAttribute('title', ok ? '' : 'Sold out');
    });

    // Visible layer: mirror the theme pill for the same size.
    scope.querySelectorAll('.js-rb-qa-pill').forEach(function (b) {
      var size = b.getAttribute('data-size');
      var ok = Object.prototype.hasOwnProperty.call(bySize, size)
        ? bySize[size]
        : data.bySizeAny[size];
      if (ok === undefined) return;

      var want = ok ? '0' : '1';
      if (b.getAttribute('data-soldout') === want) return;
      b.setAttribute('data-soldout', want);

      var label = (b.getAttribute('aria-label') || size || '').split('—')[0].trim();
      b.setAttribute('aria-label', ok ? label : label + ' — sold out');
    });
  }

  function run() {
    if (applying) return;
    applying = true;
    try {
      document.querySelectorAll('.js-quick-add-overlay').forEach(fix);
    } finally {
      applying = false;
    }
  }

  function boot() {
    run();

    /* The sheet is built lazily on hover, so catch it then as well as on the
       section re-rendering. Both paths are cheap: run() does nothing unless a
       sheet exists, and fix() writes only when a value actually changes, which
       is what keeps the observer from retriggering itself. */
    document.addEventListener('pointerover', function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('[class*="product-item"], .o-ratio__content, li')) return;
      setTimeout(run, 60);
    }, { passive: true });

    var section = document.querySelector('.js-section__collection') || document.body;
    if (!window.MutationObserver) return;
    var pending = null;
    new MutationObserver(function () {
      if (applying) return;
      clearTimeout(pending);
      pending = setTimeout(run, 80);
    }).observe(section, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
